module.exports = __webpack_public_path__ + "img/T2D_rc_20.dfe2c34b.png";